import React from "react";

function Footer() {
  return (
    <div
      style={{
        color: "#666",
        fontSize: 12,
        textAlign: "center",
        marginTop: 5,
        paddingBottom: 20,
      }}
    >
      Data Source: Bloomberg L.P.
    </div>
  );
}

export default Footer;
